<template>
  <div class="home">
    <!-- 头部 -->
    <Header class="header" type="1"></Header>
    <!-- 内容区 -->
    <div class="content">
      <!-- 菜单 -->
      <div class="menu-data-show">
        <HomeMenu
          :classType="'BasicResources'"
          :name="'数据汇聚展示'"
        ></HomeMenu>
      </div>
      <div class="menu-video">
        <HomeMenu
          :classType="'VideoMonitoring'"
          :name="'综合视频监控'"
        ></HomeMenu>
      </div>
      <div class="menu-map">
        <HomeMenu
          :classType="'GeographicInfo'"
          :name="'旅游地理信息'"
        ></HomeMenu>
      </div>
      <div class="menu-car">
        <HomeMenu :classType="'CarMonitoring'" :name="'车流量监测'"></HomeMenu>
      </div>
      <div class="menu-passenger_flow">
        <HomeMenu
          :classType="'ScenicSpotDetails'"
          :name="'景区客流监测'"
        ></HomeMenu>
      </div>
      <div class="menu-ticket">
        <HomeMenu
          :classType="'TicketMonitoring'"
          :name="'票务数据监测'"
        ></HomeMenu>
      </div>
      <div class="menu-epidemic">
        <HomeMenu
          :classType="'AnalysisPublic'"
          :name="'旅游舆情分析'"
        ></HomeMenu>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

import HomeMenu from "../components/HomeMenu.vue";
export default {
  components: { Header, HomeMenu },

  data() {
    return {
      current: "BasicResources",
    };
  },
  mounted() {
    if (!localStorage.getItem("isLogin", "1")) {
      this.$router.push({
        name: "Login",
      });
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("../assets/image/home_bg.jpg");
  .header {
    width: 100%;
    height: 10%;
  }
  .content {
    width: 100%;
    height: 90%;
    .menu-data-show {
      position: absolute;
      left: rpx(830);
      bottom: rpx(25);
    }
    .menu-video {
      position: absolute;
      left: rpx(415);
      bottom: rpx(90);
    }
    .menu-map {
      position: absolute;
      right: rpx(420);
      bottom: rpx(90);
    }

    .menu-car {
      position: absolute;
      left: rpx(159);
      bottom: rpx(284);
    }
    .menu-passenger_flow {
      position: absolute;
      right: rpx(159);
      bottom: rpx(284);
    }
    .menu-ticket {
      position: absolute;
      left: rpx(286);
      bottom: rpx(536);
    }
    .menu-epidemic {
      position: absolute;
      right: rpx(286);
      bottom: rpx(536);
    }
  }
}
</style>